import { Button } from '@daily/shared/components/Button';
import { Stack } from '@daily/shared/components/Stack';
import { Text } from '@daily/shared/components/Text';
import { Tooltip } from '@daily/shared/components/Tooltip';
import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  SkinTone,
  skinToneMap,
  useEmojiSkinTone,
} from '../../../hooks/useEmojiSkinTone';
import { robotsClassName } from '../../../lib/robots';

export const EmojiSkinTone: React.FC = () => {
  const { currentSkinTone, getModifier, resetSkinTone, selectSkinTone } =
    useEmojiSkinTone();
  const { t } = useTranslation();

  const onEmojiClick = (tone) => {
    if (!tone) resetSkinTone();
    selectSkinTone(tone);
  };

  return (
    <Stack gap={8}>
      <Text variant="strong">{t('settings.modal.emojiSkinToneTitle')}</Text>
      <div className="buttons-container">
        <Tooltip
          key="skin-tone-none"
          id="skin-tone-none"
          placement="top"
          title={t('settings.modal.noSkinTone')}
          tabIndex={-1}
        >
          <Button
            className={robotsClassName('skin-tone-none')}
            key={null}
            onClick={() => onEmojiClick(null)}
            variant={!currentSkinTone ? 'primary' : 'secondary'}
          >
            <Text El="span" variant="large">
              ✋
            </Text>
          </Button>
        </Tooltip>
        {Object.keys(skinToneMap).map((tone: SkinTone) => (
          <Tooltip
            key={`skin-tone-${tone}`}
            id={`skin-tone-${tone}`}
            placement="top"
            // i18next-extract-mark-context-next-line ["dark", "light", "medium", "mediumDark", "mediumLight"]
            title={t('settings.modal.useSkinTone', { context: tone })}
            tabIndex={-1}
          >
            <Button
              className={robotsClassName(`skin-tone-${tone}`)}
              key={tone}
              onClick={() => onEmojiClick(tone)}
              variant={
                currentSkinTone && tone === currentSkinTone
                  ? 'primary'
                  : 'secondary'
              }
            >
              <Text El="span" variant="large">
                {`✋${getModifier(tone)}`}
              </Text>
            </Button>
          </Tooltip>
        ))}
      </div>
      <style jsx>{`
        .buttons-container {
          display: flex;
          flex-direction: row;
          justify-content: space-around;
        }
      `}</style>
    </Stack>
  );
};
